'use client'
import { usePathname } from 'next/navigation'
import Link from 'next/link'
import React, { useEffect, useState } from 'react'
import Accordion from '~/components/accordion'
// import MenuItem from './MenuItem'
import { ModeTheme } from '~/components/theme'
import { AlignJustify } from 'lucide-react'
import { ResCategory } from '~/types/category'
import Wrapper from '~/components/overlay/Wrapper'
import Overlay from '~/components/overlay'
import Account from './Account'
import { Button } from '~/components/ui/button'
import ButtonLogin from './ButtonLogin'
interface Props {
    categories: ResCategory[]
}
const Menu: React.FC<Props> = ({ categories }) => {
    const pathname = usePathname()
    const [modal, setModal] = useState(false)
    const handleModal = (type: boolean) => () => setModal(type)
    useEffect(() => {
        handleModal(false)()
    }, [pathname])
    return (
        <div className='sm:hidden'>
            <div className='flex items-center gap-x-2'>
                <Account />
                <ButtonLogin />
                <ModeTheme className='rounded-xl' />
                <Button className='h-auto rounded-lg p-2 font-normal' onClick={handleModal(true)} variant={'ghost'}>
                    <AlignJustify className='size-5 cursor-pointer' />
                </Button>
            </div>
            {modal && (
                <Overlay position='top' onClose={handleModal(false)}>
                    <Wrapper className='w-full max-w-md animate-zoom-in p-4'>
                        <Accordion name='Danh mục'>
                            <Content data={categories} />
                        </Accordion>
                        {/* <MenuItem title='Học tiếng nhật' href='/languages' /> */}
                        {/* <MenuItem title='Chủ đề' elementLeft={<ModeTheme className='rounded-xl' />} /> */}
                    </Wrapper>
                </Overlay>
            )}
        </div>
    )
}

export default Menu

type ContentProps = {
    data: ResCategory[]
    onClose?: () => void
}

const Content = ({ data, onClose }: ContentProps) => {
    return (
        <ul className='rounded-lg mx-2'>
            {data.map((item) => (
                <li key={item.id} onClick={onClose}>
                    <Link
                        className='flex items-center rounded-lg px-4 py-3 text-sm hover:bg-primary-foreground/5'
                        href={`/${item.slug}`}
                    >
                        {item.name}
                    </Link>
                </li>
            ))}
        </ul>
    )
}
